import { NavbarCompanyLogo } from '@apps-common/components/common/logos'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { ButtonRoundSm } from '@apps-common/components/elements/button'
import { Header, VertSpacerLg, VertSpacerMd, VertSpacerSm } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { commonIcons } from '@apps-common/config/icons'
import { IAppNavigationOptions } from '@apps-common/hooks/useNavigation'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import { ROUTE_CREATE_ORDER, ROUTE_ORDERS } from '@apps-radionet-portal/config/private-routes'
import { OrdersFilterButton } from './OrdersFilterButton'

interface IProps {
  icons?: any
  rightComponent?: any
  leftComponent?: any
  loading: boolean
  navigateForward: (opts: IAppNavigationOptions) => void
  searchCount: number
}

export const OrdersHeader: React.FC<IProps> = ({ icons, rightComponent, leftComponent, loading, navigateForward, searchCount }) => {
  return (
    <Header classes='!max-w-[1650px]'>
      <Navbar transparent startComponents={<NavbarCompanyLogo />} icons={icons} />
      <Breadcrumbs route={ROUTE_ORDERS} />
      <div className='flex items-start justify-between'>
        <PageTitle classes='flex items-start gap-[10px] capitalize'>{ROUTE_ORDERS.label}</PageTitle>
        <div className='flex items-center gap-[5px]'>
          <Authorization roles={AUTH_CLAIMS.managementAdmin.roles} scopes={AUTH_CLAIMS.managementAdmin.scopes}>
            <ButtonRoundSm
              type='button'
              size='lg'
              className='action-success'
              callback={() => navigateForward({ routeUrl: ROUTE_CREATE_ORDER.buildPath(), route: ROUTE_CREATE_ORDER })}
            >
              <commonIcons.add />
            </ButtonRoundSm>
          </Authorization>
          <OrdersFilterButton />
        </div>
      </div>
      <VertSpacerMd className='hidden md:block' />
      <VertSpacerLg className='block md:hidden' />
      <div className='flex items-center justify-between gap-[5px] sm:px-[5px] sm:pt-0'>
        {leftComponent}
        {rightComponent}
      </div>
      {(rightComponent || leftComponent) && <VertSpacerSm />}
    </Header>
  )
}
